/**
 * Formats a coverage date the backend sends as a plain YYYY-MM-DD calendar
 * date (e.g. the E&O retroactive date) for display: "Jun 1, 2024".
 *
 * Pinned to UTC on purpose. 'YYYY-MM-DD' parses as UTC midnight, so formatting
 * it in the browser's zone would render the previous day for every user west of
 * Greenwich — a retroactive date is a calendar date on the policy, not an
 * instant, and it must read the same everywhere.
 */
const coverageDateFormat = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC'
});

export const formatCoverageDate = (isoDate: string): string | undefined => {
  const date = new Date(isoDate);
  return Number.isNaN(date.getTime())
    ? undefined
    : coverageDateFormat.format(date);
};
